import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocIsTemporaryPasswordState = atom({
  key: "ocIsTemporaryPasswordState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
